import {EVENTS_NAME} from './config.js'

const {PHONE_VIEWED_DETAIL} = EVENTS_NAME

// INPUT:  event='Phone Viewed', page_name_origin='detail'
// OUTPUT: ['Phone Viewed detail']

export const getPhoneViewedEvents = ({event, properties}) => {
  const matches =
    event === PHONE_VIEWED_DETAIL.EVENT && properties.page_name_origin === PHONE_VIEWED_DETAIL.PAGE_NAME_ORIGIN

  if (!matches) return []
  return [PHONE_VIEWED_DETAIL.EVENT_OPTIMIZELY]
}
